import React, { useEffect, useState } from "react";
import "react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit.min.css";

import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import ToolkitProvider, {
  Search,
} from "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { deleteAndRestoreProduct } from "../reduxSaga/actions";
import { Alert, Snackbar } from "@mui/material";
import RestoreFromTrashRoundedIcon from "@material-ui/icons/RestoreFromTrashRounded";
import UtilsUrl from "../utils/UtilsUrl";

const DataTableProductsColis = ({
  listProduits,
  bonneSortieName,
  typeResponseChanged,
  setNbproducts,
}) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [products, setProducts] = useState(listProduits);

  // const [openErrorAlert, setOpenErrorAlert] = useState(false);
  const [infoAlertText, setInfoAlertText] = useState();
  const [openInfoAlert, setOpenInfoAlert] = useState(false);

  const { SearchBar } = Search;

  useEffect(() => {
    setNbproducts(totalQuantity);
  }, [products]);

  // function LibelleCodeAbarre(cell, row) {
  //   if (cell === null || cell === "") {
  //     return <span>-</span>;
  //   } else {
  //     return <span>{cell}</span>;
  //   }
  // }

  const columns = [
    // {
    //   dataField: "id",
    //   text: "Image",
    //   formatter: logoFormatter,
    //   align: "center",
    //   headerAlign: "center",
    //   headerStyle: () => {
    //     return { width: "8%" };
    //   },
    // },
    typeResponseChanged
      ? {
          dataField: "product.name",
          text: "Libellé",
          formatter: (cell, row) =>
            `${row?.product?.name || ""} - ${row?.product?.barcode || ""}`,
        }
      : {
          dataField: "product.name",
          text: "Libellé",
          formatter: (cell, row) =>
            `${row?.productSellingPrice?.product?.name || ""} - ${
              row?.productSellingPrice?.product?.barcode || ""
            }`,
        },
    {
      dataField: "quantity",
      text: "quantité",
      align: "center",
      headerAlign: "center",
      headerStyle: () => {
        return { width: "15%" };
      },
    },
    // {
    //   dataField: "productCode",
    //   text: "Code article",
    //   align: "center",
    //   headerAlign: "center",
    //   headerStyle: () => {
    //     return { width: "15%" };
    //   },
    // },
    // {
    //   dataField: "barcode",
    //   text: "Code à barre",
    //   align: "center",
    //   headerAlign: "center",
    //   headerStyle: () => {
    //     return { width: "15%" };
    //   },
    // },
    // {
    //   dataField: "sku",
    //   text: "SKU",
    //   align: "center",
    //   formatter: SKUFormatter,

    //   headerAlign: "center",
    //   headerStyle: () => {
    //     return { width: "15%" };
    //   },
    // },
    // {
    //   dataField: "tva",
    //   text: "TVA",
    //   align: "center",
    //   headerAlign: "center",
    //   headerStyle: () => {
    //     return { width: "8%" };
    //   },
    // },

    // {
    //   dataField: "id",
    //   text: "Compléter",
    //   formatter: buttonFormatter,
    //   align: "center",
    //   headerAlign: "center",
    //   headerStyle: () => {
    //     return { width: "12%" };
    //   },
    // },
    // {
    //   dataField: "id",
    //   text: "Actions",
    //   formatter: buttonDeleteFormatter,
    //   align: "center",
    //   headerAlign: "center",
    //   headerStyle: () => {
    //     return { width: "12%" };
    //   },
    // },
  ];

  // const specificities = (row) => {
  //   if (row.specificities.length > 0) {
  //     return (
  //       <table
  //         class="table table-striped table-bordered table-sm"
  //         cellspacing="0"
  //         width="100%"
  //       >
  //         <thead>
  //           <tr className="text-center">
  //             <th>Libellé</th>
  //             <th>Valeur</th>
  //             <th>Description</th>
  //           </tr>
  //         </thead>
  //         <tbody>
  //           {row.specificities &&
  //             row.specificities.map((element, i) => (
  //               <tr key={i}>
  //                 <td>{element.name}</td>

  //                 <td>{element.value}</td>

  //                 <td className="text-center">{element.description}</td>
  //               </tr>
  //             ))}
  //         </tbody>
  //       </table>
  //     );
  //   }
  // };
  // const expandRow = {
  //   renderer: (row) => (
  //     <div>
  //       <p>{`Famille de produits: ${row.familyName}`}</p>
  //       <p>{`Sous-Famille de produits: ${row.subFamilyName}`}</p>
  //       <p>{`Catégorie de produits: ${row.categoryName}`}</p>
  //       <p>{`Description: ${row.description}`}</p>
  //       {specificities(row)}

  //       {/* <p>
  //         expandRow.renderer callback will pass the origin row object to you
  //       </p> */}
  //     </div>
  //   ),
  //   showExpandColumn: true,
  //   expandHeaderColumnRenderer: ({ isAnyExpands }) => {
  //     if (isAnyExpands) {
  //       return <b style={{ cursor: "pointer" }}>-</b>;
  //     }
  //     return <b style={{ cursor: "pointer" }}>+</b>;
  //   },
  //   expandColumnRenderer: ({ expanded }) => {
  //     if (expanded) {
  //       return <b style={{ cursor: "pointer" }}>-</b>;
  //     }
  //     return <b style={{ cursor: "pointer" }}>+</b>;
  //   },
  // };
  const totalQuantity =
    listProduits != null
      ? listProduits.reduce((total, item) => {
          return total + (item.quantity || 0); // Assurez-vous que `quantity` existe avant de l'additionner
        }, 0)
      : 0;
  const handleInfoClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenInfoAlert(false);
  };

  function handleTableChange({ products }) {
    return products;
  }
  const pageButtonRenderer = ({
    page,
    active,
    disable,
    title,
    onPageChange,
  }) => {
    const handleClick = (e) => {
      e.preventDefault();
      onPageChange(page);
    };
    const activeStyle = {};
    if (active) {
      activeStyle.backgroundColor = "black";
      activeStyle.color = "white";
    } else {
      activeStyle.backgroundColor = "white";
      activeStyle.color = "black";
    }
    if (typeof page === "string") {
      activeStyle.backgroundColor = "white";
      activeStyle.color = "black";
    }
    return (
      <li className="page-item">
        <button
          className="btn btn-dark"
          onClick={handleClick}
          style={activeStyle}
        >
          {page}
        </button>
      </li>
    );
  };
  const options = {
    pageButtonRenderer,
  };

  return (
    <div className="card">
      <div className="card-header">
        <h3 className="card-title">
          Produits Du Bon de Sortie{" "}
          {bonneSortieName != null ? bonneSortieName : ""}
        </h3>
      </div>
      <div className="card-body">
        <ToolkitProvider
          keyField="id"
          data={products}
          columns={columns}
          onTableChange={handleTableChange}
          exportCSV
          search
        >
          {(props) => (
            <div>
              <div className="row ml-0">
                <div>
                  <SearchBar
                    {...props.searchProps}
                    className="custome-search-field"
                    style={{ color: "black" }}
                    placeholder="Chercher"
                  ></SearchBar>
                </div>
                {/* <div className="ml-auto mr-0">
                  <MyExportCSV {...props.csvProps}></MyExportCSV>
                </div> */}
              </div>
              <div className="row">
                <BootstrapTable
                  {...props.baseProps}
                  pagination={paginationFactory(options)}
                  striped
                  hover
                  condensed
                  // expandRow={expandRow}
                />
              </div>
            </div>
          )}
        </ToolkitProvider>
      </div>

      {openInfoAlert && (
        <Snackbar
          open={openInfoAlert}
          autoHideDuration={2000}
          onClose={handleInfoClose}
          anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
        >
          <Alert variant="filled" onClose={handleInfoClose} severity="info">
            {infoAlertText}
          </Alert>
        </Snackbar>
      )}
    </div>
  );
};
export default DataTableProductsColis;
